import BaseModel from '../core/BaseModel'
//import gql from 'graphql-tag'
import StatusTDModel from './StatusTDModel';
import StatusDocumentModel from './StatusDocumentModel';
//import moment from "moment-timezone";
export default class ComputeSalaryModel extends BaseModel {

    constructor() {
        super({
                name: "computeSalary",
                tableName: 'document',
                label: "Xác nhận văn bản tính lương",
                display_key: 'code_system',
                default_order: {key: 'updated_at', direction: 'asc'}
            },
            {
                stt: {
                    name: "stt",
                    label: "STT",
                    type: "Computed",
                    width: 4,
                    class: "center",
                    computed: (data, index) => {
                        data.stt = index + 1;
                    },
                    // display: { list: true, add: false, edit: false }
                },
                id: {
                    name: 'id',
                    type: "Uuid",
                    label: 'ID',
                    primaryKey: true,
                    display: false
                },
                code_system: {
                    name: 'code_system',
                    type: "String",
                    label: 'Mã VB hệ thống',
                    width: 8,
                    class: "center",
                    filter: {type: 'input', match: 'contains'},
                    // display: false
                },
                name_litigant: {
                    name: 'name_litigant',
                    type: "String",
                    label: 'Tên đương sự',
                    width: 9,
                    class: "center",
                    sortable: false,
                    filter: {
                        type: 'input',
                        match: 'contains'
                    },
                },
                address: {
                    name: 'address',
                    type: "String",
                    label: 'Địa chỉ',
                    width: 9,
                    class: "center",
                    filter: { type: 'input', match: 'contains'},
                    // display: false
                },
                ward_ref: {
                    refs: 'ward {id name}',
                    display: false
                },
                display_ward: {
                    name: "display_ward",
                    label: "Phường / Xã",
                    width: 6,
                    class: "center",
                    filter: { type: 'input', match: 'contains'},
                    computed: (data) => {
                        data.display_ward = '';
                        if(data.ward !== undefined && data.ward !== null){
                            data.display_ward = data.ward.name;
                        }
                    }
                },
                district_ref: {
                    refs: 'district {id name}',
                    display: false
                },
                display_district: {
                    name: "display_district",
                    label: "Quận / Huyện",
                    width: 6,
                    class: "center",
                    filter: { type: 'input', match: 'contains'},
                    computed: (data) => {
                        data.display_district = '';
                        if(data.district !== undefined && data.district !== null){
                            data.display_district = data.district.name;
                        }
                    }
                },
                state_ref: {
                    refs: 'state {id name}',
                    display: false
                },
                display_state: {
                    name: "display_state",
                    label: 'Tỉnh / Thành phố',
                    width: 7,
                    class: "center",
                    filter: { type: 'input', match: 'contains'},
                    computed: (data) => {
                        data.display_state = '';
                        if(data.state !== undefined && data.state !== null){
                            data.display_state = data.state.name;
                        }
                    }
                },
                number_decision: {
                    name: 'number_decision',
                    type: "String",
                    label: 'Số quyết định',
                    width: 7,
                    class: "center",
                    filter: { type: 'input', match: 'contains'},
                    // display: false
                },
                phone_litigant: {
                    name: 'phone_litigant',
                    type: "String",
                    label: 'Số điện thoại',
                    width: 7,
                    class: "center",
                    filter: { type: 'input', match: 'contains'},
                    // display: false
                },
                code_agency: {
                    name: 'code_agency',
                    type: "String",
                    label: 'Mã cơ quan',
                    width: 7,
                    class: "center",
                    filter: { type: 'input', match: 'contains'},
                    // display: false
                },
                code_area: {
                    name: 'code_area',
                    type: "String",
                    label: 'Mã Khu vực',
                    width: 6,
                    class: "center",
                    filter: { type: 'input', match: 'contains'},
                    // display: false
                },
                type_document: {
                    name: 'type_document',
                    type: "Selection",
                    label: 'Loại VB',
                    width: 6,
                    class: "center",
                    options: [
                        {value: 1, label: '1', default: true},
                        {value: 2, label: '2'},
                        {value: 3, label: '3'},
                        {value: 4, label: '4'},
                        {value: 5, label: '5'}
                    ],
                    filter: {
                        type: 'select',
                        optionLabel: 'label',
                        optionKey: 'value',
                        match: 'equals'
                    },
                    // display: false
                },
                status_td_ref: {
                    refs: 'status_tongdat {id name}',
                    display: false
                },
                // status_td_id: {
                //     name: 'status_td_id',
                //     type: "Selection",
                //     label: 'Hình thức TĐ',
                //     options: [
                //         { value: 1, label: 'Trực tiếp', default: true },
                //         { value: 2, label: 'Trực tiếp (có xác nhận UB)'},
                //         { value: 3, label: 'Giao nhận'},
                //         { value: 4, label: 'Người thứ 3'},
                //         { value: 5, label: 'Người thứ 3 (có xác nhận UB)'},
                //         { value: 6, label: 'Niêm yết'},
                //         { value: 7, label: 'Không thành'},
                //         { value: 8, label: 'Trả lại tòa'}
                //     ],
                //     filter: {
                //         type: 'select',
                //         optionLabel: 'label',
                //         optionKey: 'value',
                //         match: 'equals'
                //     },
                //     // display: false
                // },
                status_td_id: {
                    name: "status_td_id",
                    label: "Hình thức TĐ",
                    width: 8,
                    class: "center",
                    type: "Selection",
                    models: new StatusTDModel(),
                    filter: {type: 'select', optionLabel: 'label', optionKey: 'value', match: 'equals'},
                },
                tdv_ref: {
                    refs: 'tdv {id fullname}',
                    display: false
                },
                display_tdv: {
                    name: 'display_tdv',
                    label: 'Tống Đạt Viên',
                    width: 8,
                    class: "center",
                    filter: {type: 'input', match: 'contains'},
                    computed: (data) => {
                        data.display_tdv = '';
                        if (data.tdv !== undefined && data.tdv !== null) {
                            data.display_tdv = data.tdv.fullname;
                        }
                    }
                },
                date_receipt_court: {
                    name: 'date_receipt_court',
                    type: "Date",
                    label: 'Ngày nhận VB từ tòa',
                    width: 10,
                    class: "center",
                    filter: {type: 'DateRange', match: 'custom'},
                    // display: false
                },
                date_return_court: {
                    name: 'date_return_court',
                    type: "Date",
                    label: 'Ngày trả tòa',
                    width: 10,
                    class: "center",
                    filter: { type: 'DateRange', match: 'custom'},
                    // display: false
                },
                date_change_tdv: {
                    name: 'date_change_tdv', 
                    type: "Date",
                    label: 'Ngày đổi TDV',
                    width: 13,
                    class: "center",
                    filter: { type: 'DateRange', match: 'custom'},
                    // display: false
                },
                date_complete: {
                    name: 'date_complete',
                    type: "Date",
                    label: 'Ngày hoàn thành VB',
                    width: 10,
                    class: "center",
                    filter: { type: 'DateRange', match: 'custom'},
                    // filter: { type: 'input', match: 'contains'},
                },
                total_day_done: {
                    name: 'total_day_done',
                    label: 'Tổng ngày hoàn thành VB',
                    width: 8,
                    class: "center",
                    filter: { type: 'input', match: 'equals', placeHolder: 'Nhập số ngày'},
                    computed: (data) => {
                        data.total_day_done = data.total_day_done ? data.total_day_done : 0;
                    },
                    // filter: { type: 'DateRange', match: 'custom'},
                },
                date_month_td: {
                    name: 'date_month_td',
                    type: "Date",
                    label: 'Ngày tháng TĐ',
                    width:13,
                    class: "center",
                    filter: { type: 'DateRange', match: 'custom'},
                    // display: false
                },
                status_vb_ref: {
                    refs: 'status_document {id name ordinal}',
                    display: false
                },
                // status_vb_id: {
                //     name: 'status_vb_id',
                //     type: "Selection",
                //     label: 'Trạng thái VB',
                //     options: [
                //         { value: 1, label: 'VB chờ xác nhận', default: true },
                //         { value: 2, label: 'VB đã xác nhận'},
                //         { value: 3, label: 'VB đang TĐ'},
                //         { value: 4, label: 'VB đã trả ĐPV'},
                //         { value: 5, label: 'VB ĐPV đã nhận'},
                //         { value: 6, label: 'VB hoàn thiện lại'},
                //         { value: 7, label: 'VB hoàn thành'},
                //         { value: 9, label: 'VB đã trả cơ quan'},
                //         { value: 8, label: 'VB đã tính lương'},
                //     ],
                //     filter: {
                //         type: 'select',
                //         optionLabel: 'label',
                //         optionKey: 'value',
                //         match: 'equals'
                //     },
                //     // display: false
                // },
                status_vb_id: {
                    name: "status_vb_id",
                    label: "Trạng thái VB",
                    width: 8,
                    class: "center",
                    type: "Selection",
                    models: new StatusDocumentModel(),
                    filter: {type: 'select', optionLabel: 'label', optionKey: 'value', match: 'equals'},
                },
                reason_delay: {
                    name: 'reason_delay',
                    type: "String",
                    label: 'Lý do trễ',
                    width: 8,
                    class: "center",
                    filter: { type: 'input', match: 'contains'},
                    // display: false
                },
                /*is_full_salary: {
                    name: "is_full_salary",
                    type: "Checkbox",
                    label: "Tính nguyên lương",
                    width: 8,
                    class: "center",
                },*/
                is_full_salary: {
                    name: 'is_full_salary',
                    type: "Selection",
                    type_custom:'Checkbox',
                    label: 'Tính nguyên lương',
                    width: 8,
                    class: "center",
                    options: [
                        {value: true, label: 'Có', default: true},
                        {value: false, label: 'Không'}
                    ],
                    filter: {
                        type: 'select',
                        optionLabel: 'label',
                        optionKey: 'value',
                        match: 'equals'
                    },
                    // display: false
                },

                /*is_late_salary: {
                    name: "is_late_salary",
                    type: "Checkbox",
                    label: "Tính lương VB trễ",
                    width: 8,
                    class: "center",
                },*/
                is_late_salary: {
                    name: 'is_late_salary',
                    type: "Selection",
                    type_custom:'Checkbox',
                    label: 'Tính lương VB trễ',
                    width: 8,
                    class: "center",
                    options: [
                        {value: true, label: 'Có', default: true},
                        {value: false, label: 'Không'}
                    ],
                    filter: {
                        type: 'select',
                        optionLabel: 'label',
                        optionKey: 'value',
                        match: 'equals'
                    },
                    // display: false
                },
                /*is_late: {
                    name: "is_late",
                    type: "Checkbox",
                    label: "VB trễ",
                    width: 8,
                    class: "center",
                },*/
                is_late: {
                    name: 'is_late',
                    type: "Selection",
                    type_custom:'Checkbox',
                    label: 'VB trễ',
                    width: 8,
                    class: "center",
                    options: [
                        {value: true, label: 'Có', default: true},
                        {value: false, label: 'Không'}
                    ],
                    filter: {
                        type: 'select',
                        optionLabel: 'label',
                        optionKey: 'value',
                        match: 'equals'
                    },
                    // display: false
                },
                amount_salary_tmp: {
                    name: 'amount_salary_tmp',
                    label: 'Chi phí lương',
                    width: 8,
                    class: "center",
                    filter: {type: 'input', match: 'contains'},
                    computed: (data) => {
                        data.amount_salary_tmp = '-';
                        if (data.is_confirm_salary == true) {
                            data.amount_salary_tmp = data.amount_salary;
                        }
                    }
                },
                amount_salary: {
                    name: 'amount_salary',
                    type: "Int",
                    label: '-',
                    // filter: { type: 'input', match: 'contains'},
                    display: false
                },
                is_confirm_salary: {
                    name: 'is_confirm_salary',
                    type: "Boolean",
                    label: '-',
                    // filter: { type: 'input', match: 'contains'},
                    display: false
                },
                date_comfirm_salary: {
                    name: 'date_comfirm_salary',
                    type: "Date",
                    label: 'Lương tháng',
                    width: 10,
                    class: "center",
                    filter: {type: 'DateRange', match: 'custom'},
                   // display: true
                },
                date_upd_salary: {
                    name: 'date_upd_salary',
                    type: "Date",
                    label: 'Ngày xác nhận lương',
                    width: 10,
                    class: "center",
                    filter: {type: 'DateRange', match: 'custom'},
                    // display: true
                },
                fied_detail: {
                    refs: ' note ',
                    display: false
                },

                /*date_comfirm_salary_tmp: {
                    name: "date_comfirm_salary_tmp",
                    label: "Ngày xác nhận lương",
                    width: 10,
                    class: "center",
                    filter: {type: 'DateRange', match: 'custom'},
                    computed: (data) => {
                        data.date_comfirm_salary_tmp = '-';
                        if (data.is_confirm_salary == true) {
                            if (data.date_comfirm_salary){
                                data.date_comfirm_salary_tmp = moment.tz(data.date_comfirm_salary, "Asia/Ho_Chi_Minh").format("DD/MM/yyyy");
                            }
                        }
                    }
                },*/
                /*is_late: {
                    name: 'is_late',
                    type: "Boolean",
                    label: 'Văn bản đã trễ',
                    display: false
                },*/
            },)
    }

}